const SCOPE = 'platform-group'

export const AUTH_TOKEN_KEY = `${SCOPE}/admin/token`
export const USER_KEY = `${SCOPE}/admin/user`
export const AUTHENTICATION_IN_FLIGHT = `${SCOPE}/irwin/authentication-in-flight`
export const DATAGRID_KEY = `${SCOPE}/datagrid`

export const CUSTOMER_ID = `${SCOPE}/admin/customer-id`
// Persists across logout so loginWithRedirect can route to FactSet before the FF client loads
export const NEW_AUTH_KEY = `${SCOPE}/irwin/new-auth`
